import { render } from "./IconTune.vue?vue&type=template&id=3b0bf94c"
import script from "./IconTune.vue?vue&type=script&lang=js"
export * from "./IconTune.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__